import AdminDash from "./Components/AdminDash";

export default AdminDash;
